module.exports = __webpack_public_path__ + "img/20_percent.88e9af00.png";